import React from 'react';

import { ChatMessageBlock, Stack, Text } from 'shell/components';
import theme from 'shell/themes';

const messageBlocks = [
    [
        {
            id: '0',
            created_on: 1678279757697,
            message_text: 'Message 0',
            sender_account_id: '1',
        },
        {
            id: '1',
            created_on: 1678280047998,
            message_text: 'Message 1',
            sender_account_id: '2',
        },
        {
            id: '2',
            created_on: 1678282443602,
            message_text: 'Message 2',
            sender_account_id: '1',
        },
        {
            id: '3',
            created_on: 1678284565487,
            message_text: 'Message 3',
            sender_account_id: '3',
        },
    ],
    [
        {
            id: '4',
            created_on: 1678288394371,
            message_text: 'Message 4',
            sender_account_id: '1',
        },
        {
            id: '5',
            created_on: 1678288700894,
            message_text: 'Message 5',
            sender_account_id: '3',
        },
        {
            id: '6',
            created_on: 1678289813320,
            message_text: 'Message 6',
            sender_account_id: '1',
        },
    ],
    [
        {
            id: '7',
            created_on: 1678294460422,
            message_text: 'Message 7',
            sender_account_id: '3',
        },
    ],
    [
        {
            id: '8',
            created_on: 1678299423507,
            message_text: 'Message 8',
            sender_account_id: '1',
        },
    ],
    [
        {
            id: '9',
            created_on: 1678307685233,
            message_text: 'Message 9',
            sender_account_id: '1',
        },
        {
            id: '10',
            created_on: 1678309867461,
            message_text: 'Message 10',
            sender_account_id: '1',
        },
        {
            id: '11',
            created_on: 1678310151770,
            message_text: 'Message 11',
            sender_account_id: '3',
        },
        {
            id: '12',
            created_on: 1678312363612,
            message_text: 'Message 12',
            sender_account_id: '2',
        },
    ],
    [
        {
            id: '13',
            created_on: 1678316019724,
            message_text: 'Message 13',
            sender_account_id: '2',
        },
        {
            id: '14',
            created_on: 1678319312537,
            message_text: 'Message 14',
            sender_account_id: '3',
        },
        {
            id: '15',
            created_on: 1678320327522,
            message_text: 'Message 15',
            sender_account_id: '3',
        },
        {
            id: '16',
            created_on: 1678320497704,
            message_text: 'Message 16',
            sender_account_id: '1',
        },
        {
            id: '17',
            created_on: 1678321503250,
            message_text: 'Message 17',
            sender_account_id: '2',
        },
        {
            id: '18',
            created_on: 1678321579093,
            message_text: 'Message 18',
            sender_account_id: '1',
        },
        {
            id: '19',
            created_on: 1678321963625,
            message_text: 'Message 19',
            sender_account_id: '2',
        },
    ],
];

const users = {
    1: {
        first_name: 'Georgina',
        last_name: 'Watson',
        display_name: 'George',
        profile_circle: {
            bg_color: theme.palette.ensightful.success[700],
            text_color: theme.palette.ensightful.shades[0],
        },
    },
    2: {
        first_name: 'Louisa',
        last_name: 'Kirk',
        display_name: '',
        profile_circle: {
            bg_color: theme.palette.ensightful.warning[600],
            text_color: theme.palette.ensightful.shades[0],
        },
    },
    3: {
        first_name: 'John',
        last_name: 'Walsh',
        display_name: 'Johnny',
        profile_circle: {
            bg_color: theme.palette.ensightful.secondary[800],
            text_color: theme.palette.ensightful.shades[0],
        },
    },
};

const ChatMessageBlockDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>ChatMessageBlock</Text>
            <Stack sx={{ width: '100%' }} spacing={4}>
                {messageBlocks.map((messageBlock, index) => (
                    <ChatMessageBlock
                        key={index}
                        messages={messageBlock}
                        getUserById={(id) => users[id]}
                        selfOwnerAccountId={'1'}
                        showSenderName
                    />
                ))}
            </Stack>
        </>
    );
};

export default ChatMessageBlockDemo;
